// src/components/Settings/SettingsViewArea.tsx
import React, { useRef } from "react";
import { useTheme } from "@mui/material/styles";
import { useParams } from "react-router-dom";
import { Box } from "@mui/material";

import SettingsHome from "./Pages/SettingsHome";
import ThemeSettings from "./Pages/ThemeSettings";
import AssistanceSettings from "./Pages/AssistanceSettings";

import UserManagement from "./Pages/UserManagement";
import DocumentManagement from "./Pages/DocumentManagement";

interface SettingsViewAreaProps {
  activeTab: string;
  themeMode: string;
  setThemeMode: (newMode: "light" | "dark" | "auto") => void;
  accentColor: string;
  setAccentColor: (color: string) => void;
  handleNavigate: (path: string) => void;
}

const SettingsViewArea: React.FC<SettingsViewAreaProps> = ({
  activeTab,
  themeMode,
  setThemeMode,
  accentColor,
  setAccentColor,
  handleNavigate,
}) => {
  const { id } = useParams<{ id: string }>();
  const theme = useTheme();

  // Refs
  const containerRef = useRef<HTMLDivElement | null>(null);

  let content;

  if (activeTab === "home") {
    content = <SettingsHome handleNavigate={handleNavigate} />;
  } else if (activeTab === "theme") {
    content = (
      <ThemeSettings
        themeMode={themeMode}
        setThemeMode={setThemeMode}
        accentColor={accentColor}
        setAccentColor={setAccentColor}
      />
    );
  } else if (activeTab === "assistance") {
    content = <AssistanceSettings />;
  } else if (activeTab === "users") {
    content = <UserManagement />;
  } else if (activeTab === "documents") {
    content = <DocumentManagement />;
  }

  return (
    <Box
      ref={containerRef}
      flex={1}
      p={2}
      display="flex"
      flexDirection="column"
      sx={{
        overflowY: "auto",
        scrollBehavior: "auto",
        "&::-webkit-scrollbar": {
          width: "0.4em",
        },
        "&::-webkit-scrollbar-track": {
          background: "transparent",
        },
        "&::-webkit-scrollbar-thumb": {
          background: (theme) =>
            theme.palette.mode === "dark"
              ? "rgba(255,255,255,.2)"
              : "rgba(0,0,0,.2)",
          borderRadius: "4px",
        },
      }}
    >
      {/* Include the SettingsHome component */}
      {content}
    </Box>
  );
};

export default SettingsViewArea;
